import { Link } from 'gatsby';
import React, { FC } from 'react';
import styled from 'styled-components';

import Logo from '@assets/vectors/logo.inline.svg';

const FolxLogo: FC = () => {
	return (
		<Link to="/" aria-label="Return to Folx homepage">
			<Logo alt="Folx Logo" />
		</Link>
	);
};

export default styled(FolxLogo)``;
